(() => {
  if (window.rasFreebiePickerReady) return;
  window.rasFreebiePickerReady = true;

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const sections = ['cart-drawer', 'cart-icon-bubble'];
  const discountStorageKey = 'rasSelectedRewardDiscountCode';

  // The picker's own requests use the fetch that existed before this script
  // hooked window.fetch, so they do not trigger its own eligibility re-check.
  const rawFetch = window.fetch.bind(window);

  const fetchJson = async (url, options = {}) => {
    const response = await rawFetch(url, {
      ...options,
      headers: {
        Accept: 'application/json',
        ...(options.headers || {})
      }
    });

    let data = null;

    try {
      data = await response.json();
    } catch (error) {
      data = null;
    }

    if (!response.ok) {
      const message = data && (data.description || data.message || data.status);
      throw new Error(message || `Request failed: ${url}`);
    }

    return data;
  };

  const fetchCart = () => fetchJson(root + 'cart.js');

  const idsFromPicker = (picker) => String(picker.dataset.variantIds || '')
    .split(',')
    .map((id) => Number(id.trim()))
    .filter(Boolean);

  const isFreebie = (item, ids) => ids.includes(Number(item.variant_id));

  const paidTotal = (cart, ids) => cart.items.reduce((total, item) => {
    if (isFreebie(item, ids)) return total;

    const price = item.final_line_price ?? item.line_price ?? item.original_line_price ?? 0;
    return total + Number(price);
  }, 0);

  const selectedDiscountCode = () => window.localStorage.getItem(discountStorageKey) || '';

  const setSelectedDiscountCode = (code) => {
    if (code) {
      window.localStorage.setItem(discountStorageKey, code);
    } else {
      window.localStorage.removeItem(discountStorageKey);
    }
  };

  const updateDiscountVisual = () => {
    const code = selectedDiscountCode();

    document.querySelectorAll('[data-discount-option]').forEach((button) => {
      const buttonCode = button.dataset.discountCode || '';
      const locked = button.getAttribute('aria-disabled') === 'true';
      const selected = Boolean(code && buttonCode === code && !locked);

      button.classList.toggle('is-selected', selected);
      button.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });
  };

  const applyDiscountToCheckout = () => {
    const code = selectedDiscountCode();

    document.querySelectorAll('cart-drawer form[action*="/cart"], #CartDrawer-Form').forEach((form) => {
      let input = form.querySelector('input[name="discount"][data-ras-discount-input]');

      if (!input && code) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'discount';
        input.setAttribute('data-ras-discount-input', 'true');
        form.appendChild(input);
      }

      if (input) {
        input.value = code;

        if (!code) {
          input.remove();
        }
      }
    });

    document.querySelectorAll('cart-drawer a[href*="/checkout"], #CartDrawer-Form a[href*="/checkout"]').forEach((link) => {
      link.href = code
        ? root + 'discount/' + encodeURIComponent(code) + '?redirect=/checkout'
        : root + 'checkout';
    });
  };

  const renderDrawer = (state) => {
    if (!state || !state.sections) return;

    const drawer = document.querySelector('cart-drawer');

    if (drawer && typeof drawer.renderContents === 'function') {
      drawer.renderContents(state);

      if (typeof state.item_count === 'number') {
        drawer.classList.toggle('is-empty', state.item_count === 0);
      }

      window.setTimeout(() => {
        updateDiscountVisual();
        applyDiscountToCheckout();
      }, 50);
    }
  };

  const updateCartReward = (picker, selectedFreebieId = null, discountCode = '') => {
    const ids = idsFromPicker(picker);
    const updates = {};

    ids.forEach((id) => {
      updates[id] = 0;
    });

    if (selectedFreebieId) {
      updates[selectedFreebieId] = 1;
    }

    return fetchJson(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        updates,
        discount: discountCode || '',
        sections,
        sections_url: window.location.pathname
      })
    });
  };

  const updateButtonsVisual = (picker, selectedId = null, lockUnavailableOnly = true) => {
    picker.querySelectorAll('[data-freebie-option]').forEach((button) => {
      const id = Number(button.dataset.variantId);
      const available = button.dataset.variantAvailable === 'true';
      const selected = selectedId && id === Number(selectedId);
      const locked = lockUnavailableOnly ? !available : true;

      button.classList.toggle('is-selected', Boolean(selected));
      button.classList.toggle('is-locked', locked);
      button.setAttribute('aria-disabled', locked ? 'true' : 'false');
    });
  };

  const updateButtonsFromCart = (picker, cart) => {
    const ids = idsFromPicker(picker);
    const threshold = Number(picker.dataset.threshold || 139000);
    const eligible = paidTotal(cart, ids) >= threshold;

    const selectedIds = cart.items
      .filter((item) => isFreebie(item, ids))
      .map((item) => Number(item.variant_id));

    picker.querySelectorAll('[data-freebie-option]').forEach((button) => {
      const id = Number(button.dataset.variantId);
      const available = button.dataset.variantAvailable === 'true';
      const selected = selectedIds.includes(id);
      const locked = !eligible || !available;

      button.classList.toggle('is-selected', selected);
      button.classList.toggle('is-locked', locked);
      button.setAttribute('aria-disabled', locked ? 'true' : 'false');
    });

    picker.querySelectorAll('[data-discount-option]').forEach((button) => {
      const locked = !eligible;
      button.classList.toggle('is-locked', locked);
      button.setAttribute('aria-disabled', locked ? 'true' : 'false');

      if (locked && button.classList.contains('is-selected')) {
        setSelectedDiscountCode('');
      }
    });

    updateDiscountVisual();
    applyDiscountToCheckout();
  };

  const updatePickerState = async () => {
    const picker = document.querySelector('cart-freebie-picker');
    if (!picker) return;

    const cart = await fetchCart();
    updateButtonsFromCart(picker, cart);
  };

  window.rasFreebieChoose = async (button) => {
    const picker = button.closest('cart-freebie-picker');
    if (!picker || picker.classList.contains('is-loading')) return;

    const id = Number(button.dataset.variantId);
    const available = button.dataset.variantAvailable === 'true';
    const locked = button.getAttribute('aria-disabled') === 'true';

    if (!id || !available || locked) return;

    const wasSelected = button.classList.contains('is-selected');
    const previousSelected = picker.querySelector('[data-freebie-option].is-selected');
    let state = null;

    picker.classList.add('is-loading');

    try {
      // Eligibility comes from the server-rendered picker (locked options were
      // rejected above) and is re-validated below against the cart Shopify
      // returns, so no separate /cart.js read is needed first.
      setSelectedDiscountCode('');
      updateDiscountVisual();
      applyDiscountToCheckout();

      if (wasSelected) {
        updateButtonsVisual(picker, null, false);
      } else {
        updateButtonsVisual(picker, id, false);
      }

      state = await updateCartReward(picker, wasSelected ? null : id, '');
      renderDrawer(state);
      await enforceEligibility(state);
    } catch (error) {
      console.error('Freebie choose error:', error);

      if (previousSelected) {
        updateButtonsVisual(picker, Number(previousSelected.dataset.variantId));
      } else {
        updateButtonsVisual(picker, null);
      }
    } finally {
      picker.classList.remove('is-loading');
      syncPickerAfterRender(state);
    }
  };

  let cleanupTimer = null;
  let cleanupRunning = false;

  const cleanupIneligibleFreebie = async (knownCart = null) => {
    if (cleanupRunning) return;

    const picker = document.querySelector('cart-freebie-picker');
    if (!picker) return;

    const ids = idsFromPicker(picker);
    const threshold = Number(picker.dataset.threshold || 139000);

    if (!ids.length) return;

    cleanupRunning = true;

    try {
      const cart = knownCart && Array.isArray(knownCart.items) ? knownCart : await fetchCart();

      if (paidTotal(cart, ids) < threshold) {
        const hasFreebie = cart.items.some((item) => isFreebie(item, ids));
        const hasSelectedDiscount = Boolean(selectedDiscountCode());

        setSelectedDiscountCode('');
        updateDiscountVisual();
        applyDiscountToCheckout();

        if (!hasFreebie && !hasSelectedDiscount) {
          updateButtonsFromCart(picker, cart);
          return;
        }

        const updates = {};

        cart.items.forEach((item) => {
          if (isFreebie(item, ids)) {
            updates[item.key] = 0;
          }
        });

        const state = await fetchJson(root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            updates,
            discount: '',
            sections,
            sections_url: window.location.pathname
          })
        });

        renderDrawer(state);
      } else {
        updateButtonsFromCart(picker, cart);
      }
    } catch (error) {
      console.error('Freebie cleanup error:', error);
    } finally {
      cleanupRunning = false;
    }
  };

  const queueCleanup = (delay = 300, knownCart = null) => {
    window.clearTimeout(cleanupTimer);
    cleanupTimer = window.setTimeout(() => cleanupIneligibleFreebie(knownCart), delay);
  };

  // After the picker's own update: if the returned cart is below the threshold
  // but still holds a freebie (e.g. the cart changed in another tab), remove it.
  const enforceEligibility = async (cart) => {
    const picker = document.querySelector('cart-freebie-picker');
    if (!picker || !cart || !Array.isArray(cart.items)) return;
    const ids = idsFromPicker(picker);
    const threshold = Number(picker.dataset.threshold || 139000);
    if (paidTotal(cart, ids) < threshold && cart.items.some((item) => isFreebie(item, ids))) {
      await cleanupIneligibleFreebie(cart);
    }
  };

  // Re-apply discount visuals/checkout link to the freshly rendered picker,
  // using the cart already in hand instead of fetching /cart.js again.
  const syncPickerAfterRender = (cart) => {
    window.setTimeout(() => {
      const picker = document.querySelector('cart-freebie-picker');
      if (picker && cart && Array.isArray(cart.items)) {
        updateButtonsFromCart(picker, cart);
      } else {
        updatePickerState().catch((error) => console.error('Freebie picker update error:', error));
      }
    }, 60);
  };

  // Variant ids added by a /cart/add request (FormData or JSON body).
  const addedVariantIds = (args) => {
    try {
      const init = args[1] || {};
      const body = init.body;
      if (body instanceof FormData) {
        return body.getAll('id').concat(body.getAll('items[][id]')).map(Number).filter(Boolean);
      }
      if (typeof body === 'string') {
        const data = JSON.parse(body);
        const items = Array.isArray(data.items) ? data.items : [data];
        return items.map((item) => Number(item.id)).filter(Boolean);
      }
    } catch (error) {
      return null;
    }
    return null;
  };

  if (!window.rasFreebieFetchPatched) {
    window.rasFreebieFetchPatched = true;

    const originalFetch = window.fetch.bind(window);

    window.fetch = async (...args) => {
      const response = await originalFetch(...args);
      const requestUrl = String(args[0] && args[0].url ? args[0].url : args[0]);

      try {
        if (requestUrl.includes('/cart/add')) {
          // Adding a paid product only raises the total, so it cannot make a
          // freebie ineligible: no /cart.js re-check unless a freebie variant
          // itself was added (or the request body can't be read).
          const picker = document.querySelector('cart-freebie-picker');
          const ids = picker ? idsFromPicker(picker) : [];
          const added = addedVariantIds(args);
          if (!added || added.some((id) => ids.includes(id))) {
            queueCleanup(350);
          } else {
            window.setTimeout(() => {
              updateDiscountVisual();
              applyDiscountToCheckout();
            }, 60);
          }
        } else if (requestUrl.includes('/cart/change') || requestUrl.includes('/cart/update')) {
          // These responses already contain the full cart: check eligibility
          // with it right away instead of waiting and fetching /cart.js.
          response.clone().json()
            .then((cart) => queueCleanup(60, cart))
            .catch(() => queueCleanup(350));
        }
      } catch (error) {
        queueCleanup(350);
      }

      return response;
    };
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-freebie-option]');
    if (!button || !button.closest('cart-freebie-picker')) return;

    event.preventDefault();
    event.stopPropagation();

    window.rasFreebieChoose(button);
  });

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-discount-option]');
    if (!button || !button.closest('cart-freebie-picker')) return;

    event.preventDefault();
    event.stopPropagation();

    const picker = button.closest('cart-freebie-picker');
    if (!picker || picker.classList.contains('is-loading')) return;

    const locked = button.getAttribute('aria-disabled') === 'true';
    const code = button.dataset.discountCode || '';

    if (!code || locked) return;

    const alreadySelected = button.classList.contains('is-selected');
    let state = null;

    picker.classList.add('is-loading');

    try {
      // Locked (ineligible) options were rejected above; the result is
      // re-validated against the cart Shopify returns.
      if (alreadySelected) {
        setSelectedDiscountCode('');
        updateButtonsVisual(picker, null);
        updateDiscountVisual();
        applyDiscountToCheckout();

        state = await updateCartReward(picker, null, '');
        renderDrawer(state);
      } else {
        setSelectedDiscountCode(code);
        updateButtonsVisual(picker, null);
        updateDiscountVisual();
        applyDiscountToCheckout();

        state = await updateCartReward(picker, null, code);
        renderDrawer(state);
      }

      // If the cart Shopify returned is below the threshold, the discount
      // reward does not apply: clear it, as the eligibility check did before.
      const freshPicker = document.querySelector('cart-freebie-picker') || picker;
      const ids = idsFromPicker(freshPicker);
      const threshold = Number(freshPicker.dataset.threshold || 139000);
      if (state && Array.isArray(state.items) && selectedDiscountCode() && paidTotal(state, ids) < threshold) {
        setSelectedDiscountCode('');
        state = await updateCartReward(freshPicker, null, '');
        renderDrawer(state);
      }
    } catch (error) {
      console.error('Discount reward error:', error);
    } finally {
      picker.classList.remove('is-loading');
      syncPickerAfterRender(state);
    }
  });

  // Quantity changes and removals in the drawer are checked when their
  // /cart/change response arrives (fetch hook above), using the returned cart.
  // Checking at click time read /cart.js before the change was saved.

  setSelectedDiscountCode('');
  updateDiscountVisual();
  applyDiscountToCheckout();

  // The eligibility check fetches /cart.js; run it when the browser is idle
  // instead of during page load (it exits early when the cart is empty).
  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(() => queueCleanup(0), { timeout: 3000 });
  } else {
    queueCleanup(1500);
  }
})();






